import React from 'react';
import { memo } from 'react';
import { Form, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useSearch } from '../hooks/use-search';
import Button from '/react4xp/mixins/ui/button/button';

type SearchBarProps = ReturnType<typeof useSearch>;

const SearchBar = memo(({ isLoading, search, form }: SearchBarProps) => {
    return (
        <Form
            form={form}
            onFinish={search}
            layout="inline"
        >
            <Form.Item
                style={{ width: 'calc(100% - 200px)' }}
                name="query"
                rules={[{ required: true, message: 'Введите запрос' }]}
            >
                <Input
                    prefix={<SearchOutlined style={{ color: 'gray' }} />}
                    placeholder="Найти в заголовках статей..."
                />
            </Form.Item>
            <Form.Item style={{ width: 150 }}>
                <Button
                    htmlType="submit"
                    loading={isLoading}
                >
                    Искать
                </Button>
            </Form.Item>
        </Form>
    );
});

export default SearchBar;
